import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { storageHelper } from 'src/app/misc/storage.misc';
import { jwtTokenIdentifier, swalAnimation } from 'src/app/misc/utilities.misc';
import { AuthService } from 'src/app/services/auth.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';
import Swal from 'sweetalert2';

const swalWithBootstrapButtons = Swal.mixin({
  buttonsStyling: true
})

@Component({
  selector: 'app-reset-password-request',
  templateUrl: './reset-password-request.component.html',
  styleUrls: ['./reset-password-request.component.scss']
})
export class ResetPasswordRequestComponent implements OnInit {
  requestForm!: FormGroup;

  submitted = false;
  loading = false;

  constructor(
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.requestForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.listenToAuthEvents()
  }

  get form(): { [key: string]: AbstractControl } {
    return this.requestForm.controls;
  }

  listenToAuthEvents() {
    this.authService.authSuccessEvent.subscribe((data) => {
      this.submitted = false;
      this.resetForm();
      var userAccessToken = data.token;
      storageHelper.local.store(`${jwtTokenIdentifier}`, userAccessToken);
      this.router.navigateByUrl("/dashboard");
    }
    );

    this.authService.authFailureEvent.subscribe((error: HttpErrorResponse) => {
      this.submitted = false;
      if (error.status === 400 || error.status === 404 || error.status === 401) {
        this.sweetAlertService.toastError('Erreur de connexion !', 5000, 'Veuillez vérifier vos accès et réessayer');
      } else {
        this.sweetAlertService.toastError('Erreur de connexion !', 5000, 'Le service est temporairement indisponible');
      }
    });

  }

  emailSignIn() {
    this.submitted = true;

    if (this.requestForm.invalid) {
      return;
    }
    this.loading = true;
    this.authService.forgotPassword(this.requestForm.value).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.successModal();
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.sweetAlertService.toastError('Erreur !', 5000, (error.error.message || error.error.error) || 'Le service est temporairement indisponible');
      },
    });
  }

  successModal() {
    swalWithBootstrapButtons.fire({
      title: 'Succès',
      text: "Veuillez verifier votre messagerie, un lien de récupération de mot de passe a été envoyé à votre adresse email.",
      icon: 'success',
      showCancelButton: false,
      confirmButtonText: 'Ok',
      confirmButtonColor: ' #095aa6',
      allowOutsideClick: false,
      allowEscapeKey: false,
      reverseButtons: false,
      ...swalAnimation
    }).then(() => {
      this.router.navigate(['/auth/signin']);
    })
  }

  resetForm() {
    this.requestForm.reset();
    Object.keys(this.requestForm.controls).forEach(c => {
      this.requestForm.controls[c].setErrors(null);
    });
  }

  onLogin() {
    this.router.navigate(['/auth/signin']);
  }
}
